<div class="container">

  <div *ngIf="currentUser?.needsProfileUpdate"
    style="margin-top: 18px;">
    <mat-card>
      <mat-card-title>
        Updating Your Profile
      </mat-card-title>

      <div style="margin-top:21px;">
          <div class="retrofit-form-text">
            <div [innerHTML]="textProfileNeedsUpdate"></div>
          </div>
      </div>
      <div style="margin-top: 12px;">
        <a mat-stroked-button color="primary" [routerLink]="['/account']">
          COMPLETE PROFILE
        </a>
    </div>
    </mat-card>
  </div>

  <div id='preRetrofitSubmissionMessage' *ngIf="showPreRetrofitApprovedMessage() && !isPolicyExpired()"
    class="accent-text" style="font-size: 14px; font-weight: 400; margin-top: 18px; margin-bottom: -15px;">
    Your pre-retrofit submissions have been <strong>approved</strong>, and you may now move forward with your EBB retrofit. If you are working with a contractor, please inform them.
    <span>
      (<a id='closePreRetrofitSubmissionMessage' href="javascript:void(0)" onclick="document.getElementById('preRetrofitSubmissionMessage').style.display='none'">hide message</a>)
    </span>
  </div>
  <div style="display:inline-block;"
    *ngIf="currentApp?.applicationStatus === 700000009">
    <span>
      <div [innerHTML]="femareviewmessage" class="accent-text" style="font-size: 14px; font-weight: 400; margin-top: 18px; margin-bottom: -15px;">
      </div>
    </span>
  </div>
  <h4 class="form-page-name">
    <span *ngIf="isContractor() else showApplicationTitle">
      Project
    </span>
    <ng-template #showApplicationTitle>
      Application
    </ng-template>
  </h4>

  <div *ngIf="!currentApp" class="row" style="margin: 18px;">{{this.noAppMessage}}</div>

  <div
    *ngIf="currentApp"
    fxLayout="row"
    fxLayout.lt-sm="column wrap"
    fxLayoutGap="25px">
    <div fxFlex="50%">
      <div class="form-title">{{ currentApp.name }}</div>
      <div class="form-subtitle">
        {{ currentApp._Ebb_OwnerId_Formatted }} (# {{ currentApp.applicationNumber }}, Program: {{programTypeDesc(currentApp.programType)}}) 
      </div>
    </div>
    <div fxFlex="50%" fxShow="true">
      <div *ngIf="currentApp.stateCode === 0">
        <!-- 
        <div *ngIf="currentApp?.stageCode === 700000000 || currentApp?.stageCode === 700000001"
        ngClass.gt-xs="form-timeline" ngClass="form-timeline-left">
          <span *ngIf="currentAppDue > 0" class="warn-text">
            {{currentAppDue}}
          </span>
            {{ currentAppDueMsg }}
        </div>
        -->
        <div *ngIf="currentApp?.stageCode > 700000001"
          ngClass.gt-xs="form-timeline" ngClass="form-timeline-left">
            Submitted to EBB
        </div>

        <div *ngIf="currentApp?.stageCode === 700000000"
          ngClass.gt-xs="form-lifecycle" ngClass="form-lifecycle-left">
          <div
            style="display:inline-block;"
            *ngIf="checkApplicationStatus() === 1">
            <span *ngIf="isContractor() && !isHomeowner()"> {{ currentAppStage }} - Upload Documents </span>
            <span *ngIf="isHomeowner()"> {{ currentAppStage }} - In process </span>
          </div>
          <div
            style="display:inline-block;"
            *ngIf="checkApplicationStatus() === 2">
            <span *ngIf="currentApp.programType !== 700000002 && displaySubmitApplication === true">{{ currentAppStage }} - In process </span>
            <span *ngIf="currentApp.programType !== 700000002 && displaySubmitApplication === false">{{ currentAppStage }} - Submitted </span>
            <span *ngIf="currentApp.programType === 700000002 && currentApp.submissionRejection<=700000000">FEMA Review</span>
            <span *ngIf="currentApp.programType === 700000002 && currentApp.itemsRejectedRollup === 0 &&  currentApp.submissionRejection === 700000001 ">{{ currentAppStage }} - Proceed with project </span>
          </div>
          <div
            style="display:inline-block;"
            *ngIf="checkApplicationStatus() === 3">
            <span>{{ currentAppStage }} - </span>
            <span class="warn-text"> Action required </span>
          </div>
          <div
            style="display:inline-block;"
            *ngIf="checkApplicationStatus() === 4">
            <span> Extension - </span>
            <span> {{currentApp.extensionDate | date: 'M/d/yyyy'}} </span>
          </div>
        </div>

        <div *ngIf="currentApp?.stageCode === 700000001"
          ngClass.gt-xs="form-lifecycle" ngClass="form-lifecycle-left">
          <span>
            {{ currentAppStage }}
          </span>
          <div
            style="display:inline-block;"
            *ngIf="checkApplicationStatus() === 1">
            <span *ngIf="currentApp?.stageCode === 700000001"> - Proceed with Project </span>
            <span *ngIf="currentApp?.stageCode === 700000000"> - In process </span>
          </div>
          <div
            style="display:inline-block;"
            *ngIf="checkApplicationStatus() === 2">
            <span *ngIf="displaySubmitApplication === true"> - In process </span>
            <span *ngIf="displaySubmitApplication === false"> - Submitted </span>
           </div>
          <div
            style="display:inline-block;"
            *ngIf="checkApplicationStatus() === 3">
            <span> - </span>
            <span class="warn-text"> Action required </span>
          </div>
          <div
            style="display:inline-block;"
            *ngIf="checkApplicationStatus() === 4">
            <span> Extension - </span>
            <span> {{currentApp.extensionDate | date: 'M/d/yyyy'}} </span>
          </div>
        </div>

        <div *ngIf="(currentApp?.stageCode === 700000002 || currentApp?.stageCode === 700000003)"
          ngClass.gt-xs="form-lifecycle" ngClass="form-lifecycle-left">
          <span>
            Application in Review
          </span>
          <div
            style="display:inline-block;"
            *ngIf="checkApplicationStatus() === 3">
            <span> - </span>
            <span class="warn-text"> Action required </span>
          </div>
        </div>

      </div>

      <div style="float:right;" *ngIf="currentApp.stateCode === 1">
        <div *ngIf="checkApplicationStatus() === 5"
          ngClass.gt-xs="form-timeline" ngClass="form-timeline-left">
          <span class="accent-text"> Paid </span>
        </div>
        <div *ngIf="checkApplicationStatus() === 7"
          ngClass.gt-xs="form-timeline" ngClass="form-timeline-left">
          <span class="accent-text"> Withdrawn </span>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isPolicyExpired()"
    class="warn-text" style="font-size: 14px; font-weight: 400; margin-top: 18px; margin-bottom: -15px;">
    Please contact EBB customer service for assistance. (877) 232-4300
  </div>

  <div *ngIf="currentApp && !isPolicyExpired()" style="margin-top: 15px;">
    <ng-container [ngSwitch]="currentApp.stageCode">
      <ng-template [ngSwitchCase]="700000000">
        <section>
          <mat-toolbar class="form-toolbar"
            fxShow.gt-sm fxHide.lt-md>
            <span class="form-action-title">Task List</span>
            <span class="form-toolbar-spacer"></span>
            <span *ngIf="!isInspector()" style="display:inline;">
              <a class="form-action-task"
                href="javascript:void(0)" [class.disabled]="displayProgramRulesAcknowledge"
                (click)="onPrintEvent($event)">
                Print application
              </a>
              <a *ngIf="allowWithDrawApplication"
                class="form-action-task"
                href="javascript:void(0)"
                style="margin-right: 15px;"
                (click)="onWithdrawEvent($event)">
                Withdraw application
              </a>
              <a *ngIf="!isContractor() && multipleAppsAllowed() === 2"
                href='{{uriSpaRegistration}}'
                class="form-action-task"
                style="margin-right: 15px;" [class.disabled]="displayProgramRulesAcknowledge">
                Register another property
              </a>
              <a *ngIf="displaySubmitApplication"
                href="javascript:void(0)"
                (click)="showSubmitDialog()"
                class="form-action-task"
                style="margin-right: 15px;" [class.disabled]="displayProgramRulesAcknowledge">
                Submit application
              </a>
            </span>
          </mat-toolbar>
          <div fxHide.gt-sm fxShow.lt-md>
            <div>
              <div class="form-action-title">Task List</div>
              <div *ngIf="!isInspector()" style="display:inline;">
                <div class="form-action-task">
                  <a
                    class="form-action-task"
                    href="javascript:void(0)"
                    matTooltip="Actions"
                    [matTooltipPosition]="'below'"
                    [matMenuTriggerFor]="menu">
                    ACTIONS
                  </a>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item
                      *ngIf="displaySubmitApplication"
                      (click)="showSubmitDialog()"  [disabled]="displayProgramRulesAcknowledge">
                      <span>Submit Application</span>
                    </button>
                    <button mat-menu-item
                      (click)="onPrintEvent($event)"  [disabled]="displayProgramRulesAcknowledge">
                      <span>Print Application</span>
                    </button>
                    <button mat-menu-item *ngIf="!isContractor() && multipleAppsAllowed() === 2"
                    (click)='goToUrl(uriSpaRegistration)'  [disabled]="displayProgramRulesAcknowledge">
                      <span>Register Another Property</span>
                    </button>
                    <button mat-menu-item
                      *ngIf="allowWithDrawApplication"
                      (click)="onWithdrawEvent($event)">
                      <span>Withdraw Application</span>
                    </button>
                  </mat-menu>
                </div>
              </div>
            </div>
            <mat-divider></mat-divider>
          </div>
        </section>

        <ebb-portal-program-rules-acknowledge *ngIf="displayProgramRulesAcknowledge"
        [listRule]="listRule"
      
          [programType]="displayProgramRulesAcknowledgeProgramType"
         
          (emitProgramRulesAcknowledge)="onEmitProgramRulesAcknowledged($event)"
          >
        </ebb-portal-program-rules-acknowledge>

        <ebb-portal-preretrofit
          *ngIf="!displayProgramRulesAcknowledge"
          [application]="currentApp"
          [listHelp]="listHelp"
          [listOptionSets]="resolvedOptions"
          (emitEventContractorChange)="onEmitContractorChangeEvent($event)"
          (emitEventLdpChange)="onEmitLdpChangeEvent($event)"
          (emitPermitInfoChangeEvent)="onEmitPermitInfoChange($event)"
          (emitFileChangeEvent)="onEmitFileChangeEvent($event)"
          (emitDataFormChangeEvent)="onEmitDataFormChange($event)"
          (emitSubmitApplication)="onEmitSubmitApplication($event)"
          (emitIVRChangeEvent)="onEmitIVRChange($event)"
          (emitWithDrawSGApplication)="onEmitWithDrawSG()"
          (emitReceiptPreretrofitFormChangeEvent)="onEmitReceiptsPreInfoChange()"
          [listAdditionalTaskItem]="listAdditionalTaskItem">
        </ebb-portal-preretrofit>

      </ng-template>
      
      <ng-template [ngSwitchCase]="700000001">
        <section>
          <mat-toolbar class="form-toolbar"
            fxShow.gt-sm fxHide.lt-md>
            <span class="form-action-title">Task List</span>
            <span class="form-toolbar-spacer"></span>
            <a *ngIf="displaySubmitApplication"
              href="javascript:void(0)"
              (click)="showSubmitDialog()"
              class="form-action-task"
              style="margin-right: 15px;" [class.disabled]="displayProgramRulesAcknowledge">
              Submit application
            </a>
            <a *ngIf="allowWithDrawApplication"
              class="form-action-task"
              style="margin-right: 15px;"
              href="javascript:void(0)"
              (click)="onWithdrawEvent($event)">
              Withdraw Application
            </a>
            <a *ngIf="!isContractor() && multipleAppsAllowed() === 2"
              href='{{uriSpaRegistration}}'
              class="form-action-task"
              style="margin-right: 15px;" [class.disabled]="displayProgramRulesAcknowledge">
              Register another property
            </a>
            <a
              class="form-action-task"
              href='javascript:void(0)'
              (click)="onPrintEvent($event) "[class.disabled]="displayProgramRulesAcknowledge">
              Print Application
            </a>
          </mat-toolbar>
          <div fxHide.gt-sm fxShow.lt-md>
            <div class="form-action-title">Task List</div>
            <div class="form-action-task">
              <a
                class="form-action-task"
                href="javascript:void(0)"
                matTooltip="Actions"
                [matTooltipPosition]="'below'"
                [matMenuTriggerFor]="menu">
                ACTIONS
              </a>
              <mat-menu #menu="matMenu">
                <button mat-menu-item
                  *ngIf="displaySubmitApplication">
                  <span>Submit Application</span>
                </button>
                <button mat-menu-item
                  (click)="onPrintEvent($event)">
                  <span>Print Application</span>
                </button>
                <a
                  mat-menu-item *ngIf="!isContractor() && multipleAppsAllowed() === 2"
                  href='{{uriSpaRegistration}}'
                  style="margin-right: 15px;">
                  Register another property
                </a>
                <button mat-menu-item
                  *ngIf="allowWithDrawApplication"
                  (click)="onWithdrawEvent($event)">
                  <span>Withdraw Application</span>
                </button>
              </mat-menu>
            </div>
          </div>
          <mat-divider></mat-divider>
        </section>
      <ebb-portal-program-rules-acknowledge *ngIf="displayProgramRulesAcknowledge"
      [listRule]="listRule"
        [programType]="displayProgramRulesAcknowledgeProgramType"
         
          (emitProgramRulesAcknowledge)="onEmitProgramRulesAcknowledged($event)"
          >
        </ebb-portal-program-rules-acknowledge>
        <br/>
        
       <div *ngIf="!displayProgramRulesAcknowledge"> Pre-retrofit tasks</div>
        <ebb-portal-preretrofit
          *ngIf="!displayProgramRulesAcknowledge"
          [application]="currentApp"
          [listHelp]="listHelp"
          [listOptionSets]="resolvedOptions"
          (emitEventContractorChange)="onEmitContractorChangeEvent($event)"
          (emitPermitInfoChangeEvent)="onEmitPermitInfoChange($event)"
          (emitFileChangeEvent)="onEmitFileChangeEvent($event)"
          (emitDataFormChangeEvent)="onEmitDataFormChange($event)"
          (emitSubmitApplication)="onEmitSubmitApplication($event)" 
          [listAdditionalTaskItem]="listAdditionalTaskItem">
         
        </ebb-portal-preretrofit>
       <div *ngIf="!displayProgramRulesAcknowledge">Post-retrofit tasks</div>
       <ebb-portal-postretrofit
          *ngIf="!displayProgramRulesAcknowledge"
          [application]="currentApp"
          [listHelp]="listHelp"
          [listOptionSets]="resolvedOptions"
          (emitEventContractorChange)="onEmitContractorChangeEvent($event)"
          (emitFileChangeEvent)="onEmitFileChangeEvent($event)"
          (emitDataFormChangeEvent)="onEmitDataFormChange($event)"
          (emitSubmitApplication)="onEmitSubmitApplication($event)"
          [listAdditionalTaskItem]="listAdditionalTaskItem">
        </ebb-portal-postretrofit>

      </ng-template>

      <ng-template [ngSwitchDefault]>
        <section>
          <mat-toolbar class="form-toolbar"
            fxShow.gt-sm fxHide.lt-md>
            <span class="form-action-title">Task List</span>
            <span class="form-toolbar-spacer"></span>
              <a *ngIf="displaySubmitApplication"
              href="javascript:void(0)"
              (click)="showSubmitDialog()"
              class="form-action-task"
              style="margin-right: 15px;" [class.disabled]="displayProgramRulesAcknowledge">
              Submit application
            </a>
            <span *ngIf="!isContractor() && !isInspector()">
              <a class="form-action-task"
                style="margin-right: 15px;"
                href="javascript:void(0)"
                (click)="onPrintEvent($event)" [class.disabled]="displayProgramRulesAcknowledge">
                Print application
              </a>
              <a *ngIf="showDrvPrint()"
               class="form-action-task"
                style="margin-right: 15px;"
                href="javascript:void(0)"
                (click)="onDrvEvent($event)" [class.disabled]="displayProgramRulesAcknowledge">
                Print DRV
              </a>
              <a *ngIf="showRetrofitPrint()"
               class="form-action-task"
                style="margin-right: 15px;"
                href="javascript:void(0)"
                (click)="onRetrofitEvent($event)"[class.disabled]="displayProgramRulesAcknowledge">
                Print Retrofit Verification
              </a>
              <a *ngIf="multipleAppsAllowed() === 2"
                href='{{uriSpaRegistration}}'
                class="form-action-task"
                style="margin-right: 15px;" [class.disabled]="displayProgramRulesAcknowledge"> 
                Register another property
              </a>
              <a *ngIf="allowWithDrawApplication" class="form-action-task"
                href="javascript:void(0)"
                style="margin-right: 15px;"
                (click)="onWithdrawEvent($event)">
                Withdraw application
              </a>
            </span>
          </mat-toolbar>
          <div fxHide.gt-sm fxShow.lt-md>
            <div class="form-action-title">Task List</div>
            <div *ngIf="!isContractor() && !isInspector()" style="display:inline;">
              <div class="form-action-task">
                <a
                  class="form-action-task"
                  href="javascript:void(0)"
                  matTooltip="Actions"
                  [matTooltipPosition]="'below'"
                  [matMenuTriggerFor]="menu">
                  ACTIONS
                </a>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item
                    (click)="onPrintEvent($event)"    [disabled]="displayProgramRulesAcknowledge" >
                    <span>Print Application</span>
                  </button>
                  <button mat-menu-item
                    *ngIf="showDrvPrint()"
                    (click)="onDrvEvent($event)"    [disabled]="displayProgramRulesAcknowledge">
                    <span>Print DRV</span>
                  </button>
                  <button mat-menu-item
                    *ngIf="showRetrofitPrint()"
                    (click)="onRetrofitEvent($event)"   [disabled]="displayProgramRulesAcknowledge">
                    <span>Print Retrofit Verification</span>
                  </button>
                  <button mat-menu-item
                    *ngIf="allowWithDrawApplication"
                    (click)="onWithdrawEvent($event)">
                    <span>Withdraw Application</span>
                  </button>
                </mat-menu>
              </div>
            </div>
          </div>
          <mat-divider></mat-divider>
        </section>
       <ebb-portal-program-rules-acknowledge *ngIf="displayProgramRulesAcknowledge"
       [listRule]="listRule"
        
          [programType]="displayProgramRulesAcknowledgeProgramType"
         
          (emitProgramRulesAcknowledge)="onEmitProgramRulesAcknowledged($event)"
          >
        </ebb-portal-program-rules-acknowledge>
        <ebb-portal-review *ngIf="!isInspector()&& !displayProgramRulesAcknowledge"
          [application]="currentApp"
          [listHelp]="listHelp"
          [listOptionSets]="resolvedOptions"
          (emitEventContractorChange)="onEmitContractorChangeEvent($event)"
          (emitPermitInfoChangeEvent)="onEmitPermitInfoChange($event)"
          (emitFileChangeEvent)="onEmitFileChangeEvent($event)"
          (emitDataFormChangeEvent)="onEmitDataFormChange($event)"
          (emitSubmitApplication)="onEmitSubmitApplication($event)">

        </ebb-portal-review>

        <ebb-portal-inspection *ngIf="isInspector()"
          [application]="currentApp">
        </ebb-portal-inspection>

      </ng-template>
    </ng-container>

  </div>

  <!--
    Not appear this section is needed now.  Will hold in comments a few checkins to make sure
  <div *ngIf="currentUser?.isHomeowner && currentApp?.stageCode === 700000003 && currentApp?.policy && !isPolicyExpired()"
    style="background-color: whitesmoke; border: 1px solid #d3e4ee; padding: 8px 16px;">
    <section>
    <p style="font-size: .9em;">If you are CEA Policyholder and completed your retrofit project,
      you may be eligible to receive up to a 20% discount on your CEA earthquake insurance premium.
      Please complete and submit to your residential insurer
      a CEA Earthquake Insurance Dwelling Retrofit Verification Form
      that has been signed by a civil or structural engineer or
      a licensed contractor to your homeowners insurance company.</p>

    <button mat-stroked-button color="primary"
      style="text-transform: uppercase;"
      ngStyle.gt-sm="{'margin-top': '6px'}"
      (click)="onDrvEvent($event)">
      PRINT FORM
    </button>
    </section>
  </div>
  -->

  <div *ngIf="!isInspector()" style="margin-top: 15px;">
    <div style="min-height: 50px;"></div>
  </div>

  <div *ngIf="currentApp && isInspector()" style="margin-top: 15px;">

    <div style="min-height: 250px;"></div>
  </div>

</div>
